import { createContext, useContext, useMemo, useReducer } from 'react';
import { Alert, Snackbar } from 'shell/components';

const anchorOrigin = { horizontal: 'center', vertical: 'top' };

const SnackbarContext = createContext({});

const SnackbarProvider = ({ children }) => {
    const [state, dispatch] = useReducer(
        (state, action) => {
            switch (action.type) {
                case 'OPEN_SUCCESS': {
                    return {
                        text: action.payload,
                        type: 'success',
                        open: true,
                    };
                }
                case 'OPEN_WARNING': {
                    return {
                        text: action.payload,
                        type: 'warning',
                        open: true,
                    };
                }
                case 'OPEN_ERROR': {
                    return {
                        text: action.payload,
                        type: 'error',
                        open: true,
                    };
                }
                case 'CLOSE': {
                    return {
                        ...state,
                        open: false,
                    };
                }
                default:
                    return state;
            }
        },
        {
            text: '',
            type: 'success',
            open: false,
        }
    );

    const handleClose = () => {
        dispatch({ type: 'CLOSE' });
    };

    const value = useMemo(
        () => ({
            message: {
                success: (string) => dispatch({ type: 'OPEN_SUCCESS', payload: string }),
                warning: (string) => dispatch({ type: 'OPEN_WARNING', payload: string }),
                error: (string) => dispatch({ type: 'OPEN_ERROR', payload: string }),
            },
        }),
        []
    );

    return (
        <SnackbarContext.Provider value={value}>
            {children}
            <Snackbar key={state.text} anchorOrigin={anchorOrigin} open={state.open} onClose={handleClose}>
                <Alert severity={state.type} onClose={handleClose}>
                    {state.text}
                </Alert>
            </Snackbar>
        </SnackbarContext.Provider>
    );
};

const useSnackbar = () => {
    const { message } = useContext(SnackbarContext);
    return { message };
};

export { useSnackbar };
export default SnackbarProvider;
